import { CSSProperties } from "react";
import clsx from "clsx";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TONES, Tone } from "./tones";

const SIZES = { sm: "h-8 w-8 rounded-[10px] text-[13px]", md: "h-10 w-10 rounded-xl text-[15px]", lg: "h-12 w-12 rounded-2xl text-[18px]", xl: "h-16 w-16 rounded-[20px] text-[24px]" };

type Props = { icon: IconDefinition; tone?: Tone; size?: keyof typeof SIZES; flat?: boolean; className?: string };

export default function Icon3D({ icon, tone = "indigo", size = "md", flat = false, className }: Props) {
  const colours = TONES[tone];
  const style = { "--tone-from": colours.from, "--tone-to": colours.to, "--tone-glow": colours.glow } as CSSProperties;

  // ----------------------- FLAT: SOFT TINTED SQUARE, NO GLOSS ------------------------------------
  if (flat) {
    return (
      <span className={clsx("inline-grid shrink-0 place-items-center", SIZES[size], colours.soft, colours.text, className)} aria-hidden>
        <FontAwesomeIcon icon={icon} />
      </span>
    );
  }

  return (
    <span className={clsx("icon-3d", SIZES[size], className)} style={style} aria-hidden>
      <FontAwesomeIcon icon={icon} className="drop-shadow-[0_1px_1px_rgba(0,0,0,0.25)]" />
    </span>
  );
}
